var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isActive)?_c('div',{staticClass:"ui-cursor-pointer ui-mx-3",on:{"click":function($event){return _vm.authenticate()}}},[_c('img',{attrs:{"src":_vm.iconSrc,"alt":`${_vm.provider} signin button`}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }